<div
	class="group hover:border-green-lighter transition-colors p-4 w-full rounded-xl border flex flex-row cursor-pointer items-center border-grey-lighter bg-white no-forms-background"
>
	<app-icon
		class="text-grey-darker mr-2"
		[icon]="ICON.FILE_CIRCLE_EXCLAMATION"
	></app-icon>
	<div class="flex flex-row flex-1 justify-between gap-1 items-center">
		<div class="flex flex-col gap-1">
			<p class="text-sm text-grey-darker font-bold">
				Looks like we don't have any forms for this lender.
			</p>
			<p class="text-xs text-grey-dark">Request for us to add a form.</p>
		</div>
		<div
			class="text-green text-xs flex flex-row gap-2 items-center lender-forms-bot"
		>
			<img src="/assets/images/intercom/intercom-circle-logo.svg" class="w-8" />
			Chat with us!
		</div>
	</div>
</div>
